import { unassignedSpendingApi } from '@/lib/api';
import type {
  UnassignedSpendingAssignRequest,
  UnassignedSpendingAssignResponse,
  UnassignedSpendingListResponse,
} from '@/types';

export const UnassignedSpendingService = {
  async list(): Promise<UnassignedSpendingListResponse> {
    if (!navigator.onLine) {
      throw new Error('Unassigned spending requires an internet connection');
    }
    return unassignedSpendingApi.list();
  },

  async assign(request: UnassignedSpendingAssignRequest): Promise<UnassignedSpendingAssignResponse> {
    if (!navigator.onLine) {
      throw new Error('Assigning spending requires an internet connection');
    }
    return unassignedSpendingApi.assign(request);
  },

  async discard(ids: string[]): Promise<void> {
    if (!navigator.onLine) {
      throw new Error('Discarding spending requires an internet connection');
    }
    await unassignedSpendingApi.discard(ids);
  },
};
